import { render, staticRenderFns } from "./MarketAccountPage.vue?vue&type=template&id=42f5167c"
import script from "./MarketAccountPage.vue?vue&type=script&lang=js"
export * from "./MarketAccountPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports